export class Permission {

    id: number|undefined;
    active: boolean;
    code: string;
    label:string;
  
  }